import React from 'react';
import classnames from 'classnames';
import HamburgerIcon from 'images/icons/controls/hamburger.svg?react-svg';
import styles from './navWrapper.mod.scss';

export default function NavWrapper({ className, toggleRef, children }) {
  return (
    <nav className={classnames(styles.nav, className)}>
      <div ref={toggleRef} className={styles.hamburgerContainer}>
        <HamburgerIcon width={24} height={18} />
      </div>

      {children}
    </nav>
  );
}
